/* eslint-disable */ 

export class Marker {
    get selected () {
        return this._inputNode.checked;
    }

    get imgForPrintURL () {
        return this._imgNode.src;
    }

    constructor({ imgPath, dataTarget, targetId }) {
        const root = document.getElementById('markers-table');

        const parentDiv = document.createElement('div');
        parentDiv.classList.add('markers');
        parentDiv.classList.add('col-lg-3');
        parentDiv.classList.add('col-md-auto');
        root.appendChild(parentDiv);


        this._checkableDiv = document.createElement('div');
        this._checkableDiv.classList.add('custom-control');
        this._checkableDiv.classList.add('custom-checkbox');
        this._checkableDiv.classList.add('image-checkbox');
        parentDiv.appendChild(this._checkableDiv);

        this._inputNode = document.createElement('input');
        this._inputNode.id = `input-${targetId}`
        this._inputNode.type = 'checkbox';
        this._inputNode.classList.add('d-none');
        this._inputNode.classList.add('custom-control-input');
        this._inputNode.disabled = true;
        this._checkableDiv.appendChild(this._inputNode);

        this._labelNode = document.createElement('label');
        this._labelNode.className = 'custom-control-label';
        this._labelNode.setAttribute('for', `input-${targetId}`);
        this._checkableDiv.appendChild(this._labelNode);

        this._imgNode = document.createElement('img');
        this._imgNode.src = imgPath;
        this._imgNode.classList.add('img-fluid');
        this._imgNode.classList.add('border');
        this._imgNode.classList.add('border-3');
        this._imgNode.classList.add('rounded-circle');
        this._labelNode.appendChild(this._imgNode);
    }

    show () {
        this._inputNode.classList.remove('d-none');
        this._inputNode.disabled = false;
    }

    hide () {
        this._inputNode.classList.add('d-none');
        this._inputNode.disabled = true;
        this._inputNode.checked = false;
    }

    select () {
        this._inputNode.checked = true;
    }

    unSelect () {
        this._inputNode.checked = false;
    }
}